export default {"src":"__ASTRO_ASSET_IMAGE__B1dalqJ$__","width":1741,"height":1686,"format":"jpg"}